import { orderBy, query } from "firebase/firestore";

import getCommentsSubCollRef from "./getCommentsSubCollRef";

const getCommentsQuery = (appId, applicantId, sectionId) => {
  return query(getCommentsSubCollRef(appId, applicantId, sectionId), orderBy('createdAt'));
}

export default getCommentsQuery;
